<template>
  <div
    :class="{ 'app-progress-bar--hidden': !visible }"
    class="app-progress-bar"
  >
    <div class="app-progress-bar__container">
      <small
        v-if="progressLabel"
        class="app-progress-bar__label"
      >
        {{ progressLabel }}
      </small>
      <div class="app-progress-bar__inner">
        <div
          class="app-progress-bar__filled"
          :style="`transform: scaleX(${filledWidth});`"
        />
      </div>
    </div>
  </div>
</template>

<script>
/**
 * <app-progress-bar></app-progress-bar>
 * @desc display the step progress
 */
export default {
  // Name
  name: 'app-progress-bar',

  // Props
  props: {
    circles: Number,
    steps: Object,
    currentStep: String,
    visible: {
      type: Boolean,
      default: true
    }
  },

  // Computed
  computed: {
    filledWidth () {
      return (this.stepIndex) / this.stepTotal
    },
    stepIndex () {
      if (!this.steps || !this.currentStep) return
      return Object.keys(this.steps).indexOf(this.currentStep)
    },
    stepTotal () {
      if (!this.steps) return
      return Object.keys(this.steps).length
    },
    progressLabel () {
      if (!this.steps || !this.currentStep) return
      return this.steps[this.currentStep].progressLabel
    }
  },

  mounted () {
    this.steps = this.steps
  }
}
</script>

<style scoped lang="scss">
.app-progress-bar {
  position: relative;
  // visibility: visible;

  &--hidden {
    visibility: hidden;
    // margin-bottom: -40px;
  }

  @include breakpoint('tablet-portrait-up') {
    margin: auto;
    width: 560px;
  }

  @include breakpoint('tablet-landscape-up') {
    width: 845px;
  }

  @include breakpoint('desktop-up') {
    width: 970px;
  }

  &__container {
    // position: absolute;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;

    // margin: 10px 0 0;
    z-index: 2;
    width: 100%;

    @include breakpoint('mobile-only') {
      padding: 0 15px;
      margin-top: 10px;
      // margin: auto;
      // width: 560px;
    }

    // @include breakpoint('tablet-landscape-up') {
    //   width: 845px;
    // }

    // @include breakpoint('desktop-up') {
    //   width: 970px;
    // }
  }

  &__inner {
    position: relative;
    width: 100%;
    text-align: center;
    border-bottom: 6px solid #E6E6E6;
  }

  &__filled {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 6px;
    margin: auto;
    transform-origin: 0% 0;
    background-color: $theme-text-blue;
    transition: transform .5s ease-out;
  }

  &__label {
    margin-bottom: 5px;
    color: $theme-text-grey;
    font-size: 12px;
  }
}
</style>
